import firebase from '../firebaseConfig';
import "../styles/dashboard.css"
import {useEffect, useState} from "react";
import DashBoardNavBar from "./DashboardNavbar";
import { useNavigate } from "react-router-dom";
import NoSubscription from "./NoSubscription";
import Cycles_Content from "./Cycles_Tabs/1_Cycles";
import { useAdminView } from '../contexts/AdminViewContext';

const Cycles = ({ user }) => {
    const [planValidity, setPlanValidity] = useState(0);
    const [userName, setUserName] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { isAdminView, viewedUser, exitAdminView } = useAdminView();
    const navigate = useNavigate();

    useEffect(() => {
        const checkPlanValidity = async () => {
            if (user) {
                // Utiliser l'utilisateur visualisé si en mode admin, sinon l'utilisateur connecté
                const targetUser = viewedUser || user;
                const userId = targetUser.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                const docSnapshot = await docRef.get();
                if (docSnapshot.exists) {
                    const data = docSnapshot.data();
                    const endSubscriptionDate = data.endSubscriptionDate?.toDate();
                    setUserName(data.username)
                    if (endSubscriptionDate > new Date()) {
                        setPlanValidity(2);
                        const tutorialCompleted = data.tutorialCompleted;
                        if(tutorialCompleted === false && !isAdminView){
                            navigate('/welcome');
                        }
                    } else {
                        setPlanValidity(1);
                    }
                }
            } else {
                // Utilisateur non connecté, gérer le cas approprié ici si nécessaire
                // Par exemple, rediriger vers la page de connexion
                navigate('/login');
            }
            setIsLoading(false);
        };
        checkPlanValidity();
    }, [user, viewedUser, isAdminView, navigate]);

    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            { planValidity === 2 &&
                <>
                    <DashBoardNavBar userName={userName} boldItem={'cycles'} isAdminView={isAdminView} exitAdminView={exitAdminView}/>
                    <section className="position-relative pt-2">
                        <div className="container mainContainer">
                            <Cycles_Content user={viewedUser || user}/>
                        </div>
                    </section>
                </>
            }
            { planValidity === 1 &&
                <NoSubscription/>
            }
            <div className="mt-5"></div>
        </>
    );
}

export default Cycles;